export const DESCRIPTION_HELP_TEXT =
  "A short caption that explains what the photo. This helps customers understand what they're seeing. This field is read only and cannot be modified.";

export const CATEGORY_PLACEHOLDER = 'Select how this media relates to your business';
export const CATEGORY_HELP_TEXT =
  'Describes how the photo or video relates to your business (e.g., interior, product, team). Helps Google show it in the right context on your profile.';
